


















































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import * as rules from '@/utils/validationRules'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray } from '@/utils/groupBy'
import flux from '@/api/flux'

@Component({
  name: 'EditDartyPro',    
  components:{EditBaseFlux},  
  props: {   
    rtbEditable:{
      type:Boolean,
      default:true      
    },
    statusEditable:{
      type:Boolean,
      default:true      
    },
    pbEditable:{
      type:Boolean,
      default:true      
    },
    tarifEditable:{
      type:Boolean,
      default:true      
    },
  }
})
export default class EditDartyPro extends Vue {
  
  private flux = getDefaultAloFlux()

  private rtbEditable!:boolean
  private statusEditable!:boolean
  private pbEditable!:boolean
  
  private limitable:boolean = this.flux.flcParamMaxPhotos > 0

  
  
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloFlux) {    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)
  }  

  get rtbs(){
    return [0,1,2,3,4,5,6,7,8,9,10]
  }

  get statutCompactGroupsList(){
    return this.$store.myGetters.statutCompactGroupsList
  }

  get statutCompactGroupsGroup(){
    //@ts-ignore    
    return toSubArray(this.statutCompactGroupsList,2)
  }

  get tarifModelsList(){
    return [ {id:0,libelle:"Aucun"},...this.$store.myGetters.tarifModelsList]
  }

  updateList(list:Array<number>,id:number,selected:boolean) {
    if(!selected) list.push(id)
    else list.splice(list.findIndex(it => it == id),1)
  }
  
  @Watch("flux")
  fluxChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.limitable = this.flux.flcParamMaxPhotos > 0
  }

  @Watch("limitable")
  limitableChanged(newValue:boolean) {
    //@ts-ignore
    if(!newValue)  this.flux.flcParamMaxPhotos = 0
  }
  
}
